import { useTrackingDropdownMenu } from '@ecomm/header/hooks/useTrackingDropdownMenu'
import { DesktopDropdownMenu } from '../DesktopDropdownMenu'
import { AccountMenuItems } from './AccountMenuItems'

type AccountDropdownMenuProps = {
  readonly onToggleDropdown: (close?: boolean) => void
  readonly showDropdown: boolean
  // (sideNav === true) => This dropdown menu is being displayed in the side nav and not in desktop mode
  readonly sideNav: boolean
}

export function AccountDropdownMenu({
  showDropdown,
  sideNav,
  onToggleDropdown
}: AccountDropdownMenuProps) {
  const trackClick = useTrackingDropdownMenu()

  const handleOnClick = (label: string) => {
    onToggleDropdown(true)
    trackClick(label)
  }

  return (
    <DesktopDropdownMenu
      title="AccountDropdownMenu"
      showDropdown={showDropdown}
      sideNav={sideNav}
      baseClassNames="top-full rounded-lg bg-neutral-black z-10 w-full shadow-lg border lg:border-solid border-slate-100 before:absolute before:-top-1 before:left-1/2 before:z-[0] before:block before:h-6 before:w-6 before:-translate-x-1/2 before:rotate-45 before:transform before:bg-white lg:absolute lg:left-1/2 lg:w-max lg:-translate-x-1/2 lg:bg-white lg:before:content-['']"
      dataTestId="account-dropdown-menu"
    >
      <AccountMenuItems
        showDropdown={showDropdown}
        handleOnClick={handleOnClick}
      />
    </DesktopDropdownMenu>
  )
}
